import {GameObjectsTags} from '../../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';
import {FULL_BATTERY_LEVEL} from '@/stores/ClickerStateStore/ClickerStateStore.constants';

import {injected} from 'brandi';

import {BaseComponent} from '@specials/gcs-engine';

import {LocationType} from '@/services/ProjectAuthApi/types';
import {GameStatusStore} from '@/stores/GameStatusStore/GameStatusStore';
import {GiftsStore} from '@/stores/GiftsStore/GiftsStore';
import {WinnersStore} from '@/stores/WinnersStore/WinnersStore';

import {ISpaceshipDataComponent} from './SpaceshipDataComponent';

export class ResultsSpaceshipDataComponent extends BaseComponent implements ISpaceshipDataComponent {
  public location: LocationType;
  public batteryChargeLevel: number;

  constructor(
    private readonly gameStatusStore: GameStatusStore,
    private readonly giftsStore: GiftsStore,
    private readonly winnersStore: WinnersStore,
  ) {
    super();

    this.tag = GameObjectsTags.SpaceshipDataComponent;
    this.location = LocationType.Location1;
    this.batteryChargeLevel = FULL_BATTERY_LEVEL;
  }

  get isHidden(): boolean {
    return (
      this.gameStatusStore.isStatusGameFinishedBeforeResults() ||
      (this.gameStatusStore.isStatusGameFinishedAfterResults() && this.giftsStore.isShowResultsGiftModal()) ||
      (this.gameStatusStore.isStatusGameFinishedAfterResults() && !this.winnersStore.getWinner())
    );
  }
}

injected(ResultsSpaceshipDataComponent, DI_TOKENS.gameStatusStore, DI_TOKENS.giftsStore, DI_TOKENS.winnersStore);
